import { api } from "../services/api";
import { createContext, useContext, useState, useEffect } from "react";

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  // 🔓 Cargar settings públicos

  const loadPublicSettings = async () => {
    try {
      // const res = await fetch("/api/app-public-settings");
      const res = await api.get("/api/app-public-settings");
      setSettings(prev => ({ ...prev, ...res.data }));
    } catch (err) {
      console.error("❌ Error loading public settings:", err);
    } finally {
      setLoading(false);
    }
  };

  // 🔐 Cargar settings privados si está logueado
  const loadUserSettings = async () => {
    try {
      const res = await api.get("/api/user-settings"); // ✅ usa instancia con token
      setSettings(prev => ({ ...prev, ...res.data }));
    } catch (err) {
      console.error("❌ Error loading user settings:", err);
    }
  };

  useEffect(() => {
    loadPublicSettings(); // siempre

    const token = localStorage.getItem("token");
    if (token) {
      loadUserSettings();
    }
  }, []);

  useEffect(() => {
    const handler = () => loadUserSettings();
    window.addEventListener("userLoggedIn", handler);
    return () => window.removeEventListener("userLoggedIn", handler);
  }, []);

  useEffect(() => {
    const handler = () => setSettings({});
    window.addEventListener("userLoggedOut", handler);
    return () => window.removeEventListener("userLoggedOut", handler);
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
